import { useEffect, ContextType, useState, useRef } from "react";
import { Context } from ".";

type C = ContextType<typeof Context>;

type Data = {
  transactions: C["transactions"][0];
  events: C["events"][0];
  budgets: C["budgets"][0];
  incomeCategories: C["incomeCategories"][0];
  expenseCategories: C["expenseCategories"][0];
};

export const LS_KEY = "context_data";

export const useSynchronization = (data: Data) => {
  const interval = useRef<any>(null);
  const [lastSync, setLastSync] = useState<Date | null>(null);

  useEffect(() => {
    interval.current = setInterval(() => {
      localStorage.setItem(LS_KEY, JSON.stringify(data));
      setLastSync(new Date());
    }, 5000);

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [data]);

  return lastSync;
};
